<!--
  Panel de configuracion global. Estructura: cabecera (titulo + pestañas + cerrar),
  cuerpo con un solo scroll y pie solo en la vista de sensores.
  Estilos compartidos de filas (.off-section, .off-item, .off-stepper) en
  offsidebar.component.scss; los usan tambien app-configuration y app-other-configuration.
-->
<div class="off-panel">
  <div class="header-title">
    <div class="off-header-text">
      <h3 class="m-0">{{ "offsidebar.global-config" | translate }}</h3>
      <ng-container *ngIf="mode_configuration !== 'global'">
        <p class="m-0" *ngIf="config_mode !== 'fuzzy-logic'">{{ "offsidebar.farm-level" | translate }}</p>
        <p class="m-0" *ngIf="config_mode === 'fuzzy-logic'">{{ "offsidebar.client-level" | translate }}</p>
      </ng-container>
    </div>
    <div class="off-header-actions">
      <!-- Pestañas: configuracion global / sensores -->
      <button
        type="button"
        class="off-tab"
        [class.active]="mode_configuration === 'global'"
        [attr.aria-label]="'offsidebar.config.settings' | translate"
        [attr.title]="'offsidebar.config.settings' | translate"
        (click)="mode_configuration = 'global'"
      >
        <em class="fa fa-cogs"></em>
      </button>
      <button
        type="button"
        class="off-tab"
        [class.active]="mode_configuration !== 'global'"
        *ngIf="is_client && permissions.view_parametricpreference"
        (click)="mode_configuration = 'sensor'"
      >
        <app-image-color
          [width]="'16px'"
          [height]="'16px'"
          [url]="'menu-icons/waterwise.svg '"
          [color]="'#ffffff'"
        ></app-image-color>
      </button>
      <!-- Compacto: el panel cubre toda la pantalla (y el boton que lo abre), asi que se cierra aqui -->
      <button
        type="button"
        class="close-offsidebar only-compact"
        [attr.aria-label]="'general.close' | translate"
        (click)="closeOffsidebar()"
      >
        &times;
      </button>
    </div>
  </div>

  <!-- Cuerpo: unico scroll del panel -->
  <div class="off-body" [class.off-body-flush]="mode_configuration === 'sensor'">
    <ng-container *ngIf="mode_configuration === 'global'">
      <!-- Personalizacion: tamaño de fuente, idioma y tema (antes en el pie fijo) -->
      <section class="off-section off-section-first">
        <h6 class="off-section-title">{{ "offsidebar.config.personalization" | translate }}</h6>

        <div class="off-item">
          <span class="off-item-label">{{ "offsidebar.font-size" | translate }}</span>
          <div class="off-segmented" role="group" [attr.aria-label]="'offsidebar.font-size' | translate">
            <button
              type="button"
              [class.active]="storageService.size < 0 && storageService.size >= -storageService.limit"
              [attr.aria-label]="'offsidebar.decrease' | translate"
              (click)="changeFont('reduce')"
            >
              A<em class="fa fa-minus"></em>
            </button>
            <button
              type="button"
              [class.active]="storageService.size === 0"
              [attr.aria-label]="'offsidebar.font-default' | translate"
              (click)="changeFont('default')"
            >
              A
            </button>
            <button
              type="button"
              [class.active]="storageService.size > 0 && storageService.size <= storageService.limit"
              [attr.aria-label]="'offsidebar.increase' | translate"
              (click)="changeFont('add')"
            >
              A<em class="fa fa-plus"></em>
            </button>
          </div>
        </div>

        <button type="button" class="off-item off-item-link" (click)="changeLanguage()">
          <span class="off-item-label">{{ "offsidebar.config.lenguajes" | translate }}</span>
          <span class="off-item-value">
            <img
              class="image-language"
              *ngIf="language.image && language.code"
              [src]="language.image"
              [alt]="language.code"
            />
            {{ language.text }}
          </span>
        </button>

        <div class="off-item off-item-themes">
          <span class="off-item-label">{{ "offsidebar.config.temas" | translate }}</span>
          <div class="off-themes">
            <div class="setting-color">
              <label>
                <input
                  type="radio"
                  name="setting-theme"
                  [(ngModel)]="currentTheme"
                  (ngModelChange)="setTheme()"
                  value="A"
                />
                <span class="icon-check"></span>
                <span class="split">
                  <span class="color" style="background-color: #204349"></span>
                  <span class="color bg-primary-light"></span>
                </span>
                <span class="color" style="background-color: white;"></span>
              </label>
            </div>
            <div class="setting-color">
              <label>
                <input
                  type="radio"
                  name="setting-theme"
                  [(ngModel)]="currentTheme"
                  (ngModelChange)="setTheme()"
                  value="B"
                />
                <span class="icon-check"></span>
                <span class="split">
                  <span class="color bg-green"></span>
                  <span class="color bg-green-light"></span>
                </span>
                <span class="color" style="background-color: white;"></span>
              </label>
            </div>
            <div class="setting-color">
              <label>
                <input
                  type="radio"
                  name="setting-theme"
                  [(ngModel)]="currentTheme"
                  (ngModelChange)="setTheme()"
                  value="C"
                />
                <span class="icon-check"></span>
                <span class="split">
                  <span class="color" style="background-color: #007a79"></span>
                  <span class="color bg-secondary-light"></span>
                </span>
                <span class="color" style="background-color: white;"></span>
              </label>
            </div>
            <div class="setting-color">
              <small class="beta-tag">{{ "offsidebar.config.beta" | translate }}</small>
              <label>
                <input
                  type="radio"
                  name="setting-theme"
                  [(ngModel)]="currentTheme"
                  (ngModelChange)="setTheme()"
                  value="H"
                />
                <span class="icon-check"></span>
                <span class="split">
                  <span class="color bg-inverse-light"></span>
                  <span class="color bg-inverse"></span>
                </span>
                <span class="color bg-black"></span>
              </label>
            </div>
          </div>
        </div>
      </section>

      <app-configuration
        [permissions]="permissions"
        [farm]="farm"
        [mode]="mode"
        (getFarm)="getFarm($event)"
        [autimaticTestTime]="autimaticTestTime"
        [status_test_alert]="status_test_alert"
      ></app-configuration>

      <app-other-configuration></app-other-configuration>
    </ng-container>

    <ng-container *ngIf="mode_configuration === 'sensor'">
      <div *ngIf="farm && farm.id && (!this.globalFunction.validateSoloAdmin() || mode === 1)">
        <app-config-sensors-device
          [type]="'farm'"
          [id]="farm.id"
          [buttons_header]="false"
          [config_mode]="config_mode"
          [viewNotifications]="true"
        ></app-config-sensors-device>
      </div>
    </ng-container>
  </div>

  <!-- Pie solo en sensores: tipo de configuracion (min-max / AI) -->
  <div class="off-footer" *ngIf="mode_configuration !== 'global'">
    <div class="off-segmented off-segmented-light" role="group">
      <button
        type="button"
        [class.active]="config_mode === 'min-max'"
        (click)="config_mode = 'min-max'"
      >
        {{ "offsidebar.max-min" | translate }}
      </button>
      <button
        type="button"
        *ngIf="globalFunction.validateSoloAdmin()"
        [class.active]="config_mode === 'fuzzy-logic'"
        (click)="config_mode = 'fuzzy-logic'"
      >
        AI
      </button>
    </div>
  </div>
</div>
